import { t } from 'i18next';
import * as Yup from 'yup';

import './_yup.extensions';

import { EMAIL_REGEX } from 'settings/regex';

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required(t('LABEL_EMAIL_OR_NUMBER_CLIENT_REQUIRED', { ns: 'loginPage' }))
    .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC'))
    .test(
      'email',
      t('LABEL_EMAIL_OR_NUMBER_CLIENT__ERROR', { ns: 'loginPage' }),
      function (value) {
        return (
          !!value &&
          (EMAIL_REGEX.test(value) || /^\d{8}[A-Za-z0-9]?$/.test(value))
        );
      }
    ),
  password: Yup.string().required(
    t('LABEL_ERROR_PASSWORD_REQUIRED', { ns: 'loginPage' })
  ),
  turnstileToken: Yup.string().turnstileRequired(
    t('FORM_TURNSTILE_REQUIRED_ERROR', { ns: 'translation' })
  ),
});

export const validationSchemaResetPassword = Yup.object().shape({
  email: Yup.string()
    .required(t('LABEL_ERROR_EMAIL_REQUIRED', { ns: 'loginPage' }))
    .email(t('LABEL_ERROR_INVALID_EMAIL_MODAL', { ns: 'loginPage' }))
    .matches(/^[^&]*$/, t('LABEL_ERROR_CARAC'))
    .test(
      'email',
      t('LABEL_ERROR_INVALID_EMAIL_MODAL', { ns: 'loginPage' }),
      function (value) {
        return !!value && EMAIL_REGEX.test(value);
      }
    ),
  turnstileToken: Yup.string().turnstileRequired(
    t('FORM_TURNSTILE_REQUIRED_ERROR', { ns: 'translation' })
  ),
});
